import { render, staticRenderFns } from "./AchievementItem.vue?vue&type=template&id=22676558&scoped=true"
import script from "./AchievementItem.vue?vue&type=script&lang=js"
export * from "./AchievementItem.vue?vue&type=script&lang=js"
import style0 from "./AchievementItem.vue?vue&type=style&index=0&id=22676558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22676558",
  null
  
)

export default component.exports